import * as React from 'react';
import { Dropdown } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
const _ = require('lodash');

interface State {
    setOptions: any[];
}

interface Props {
    setFilter: any;
    onChange: any;
}

export default class SetFilter extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            setOptions: []
        });
    }
    componentDidMount() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        axios.post(url, {
            mode: 'get',
            defaults: {
            },
            options:  [
                { 'name': 'setName', 'input': 1},
                { 'name': 'setName', 'input': 2},
                { 'name': 'setName', 'input': 3},
                { 'name': 'setName', 'input': 4},
                { 'name': 'setName', 'input': 5},
                { 'name': 'setName', 'input': 6},
                { 'name': 'setName', 'input': 7},
                { 'name': 'setName', 'input': 8},
                { 'name': 'setName', 'input': 9},
                { 'name': 'setName', 'input': 10}
                ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;
                    let name = _.map((responseObject), 'value');
                    let result = [];
                    result.push({value: '', text: 'All'});
                    for (let i = 0; i < name.length; i++) {
                        result.push({value: i + 1, text: name[i]});
                    }
                    _this.setState({
                        setOptions: result
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of set names, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('setFilter() error: ', error);
            });
    }

    render() {

        return (
                <Dropdown
                    className="censusDropDown"
                    placeholder="Set"
                    clearable
                    search
                    selection
                    options={this.state.setOptions}
                    value={this.props.setFilter}
                    onChange={(event: any, data: any) => this.props.onChange(event, data)}
                />
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/sys/setFilter.tsx